import "core-js/modules/es.array.concat.js";
import { useRef, useEffect } from 'react';
import { BarChart, LineChart, PieChart } from 'chartist';
function useChartist(hostRef, props) {
  var chartRef = useRef(null);
  var type = props.type,
    options = props.options,
    data = props.data,
    preserveAspectRatio = props.preserveAspectRatio;
  useEffect(function () {
    if (!hostRef.current) return;
    var chart = null;
    switch (type) {
      case 'Bar':
        chart = new BarChart(hostRef.current, data, options);
        break;
      case 'Line':
        chart = new LineChart(hostRef.current, data, options);
        break;
      case 'Pie':
        chart = new PieChart(hostRef.current, data, options);
        break;
    }
    chartRef.current = chart;
    return function () {
      var _chartRef$current;
      (_chartRef$current = chartRef.current) === null || _chartRef$current === void 0 ? void 0 : _chartRef$current.detach();
    };
  }, [hostRef, options, data, type]);
  var chartHeight = options === null || options === void 0 ? void 0 : options.height;

  // This effect adds a viewBox attribute to the generated SVG element,
  // which allows it to grow/shrink along with the container when the size
  // of it changes - in case the change is not due to a window resize,
  // which Chartist already handles by redrawing the chart.
  useEffect(function () {
    function updateViewBox(data) {
      var _data$svg;
      var node = (_data$svg = data.svg) === null || _data$svg === void 0 ? void 0 : _data$svg._node;
      if (node) {
        node.setAttribute('viewBox', "0 0 ".concat(node.clientWidth, " ").concat(chartHeight || node.clientHeight));
        if (preserveAspectRatio) {
          node.setAttribute('preserveAspectRatio', preserveAspectRatio);
        }
      }
    }
    if (chartRef.current) {
      chartRef.current.on('created', updateViewBox);
    }
  }, [chartRef, preserveAspectRatio, chartHeight]);
}
export default useChartist;